<template>
    <span>
        {{ value | date }}
    </span>
</template>

<script>
import Column from '@mixins/Column';

export default {
    mixins: [ Column ]
}
</script>
